export function initTracking() {

  // 二重実行防止
  if (window.__keen_tracking_initialized) return;

  window.__keen_tracking_initialized = true;

  KeenTracking.ready(function () {

    const md = new MobileDetect(window.navigator.userAgent);
    if (md.is('bot')) return; // ボットなら何もしない

    // -------------------------------
    // ページビュー送信
    // -------------------------------
    const pageViewPayload = {
      url: window.location.href,
      referrer: document.referrer || null,
      timestamp: new Date().toISOString(),
      timestamp_jst: new Date().toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" }),
      timezone_offset: new Date().getTimezoneOffset()
    };

    fetch('/api/keen_events', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        event_type: 'page_views',
        payload: pageViewPayload
      })
    })
    .then(res => {
      if (!res.ok) {
        console.warn('Keen page_view blocked:', res.status);
      }
    })
    .catch(err => console.error('Failed to send page view event:', err));



    // -------------------------------
    // クリックトラッキング
    // -------------------------------
    let lastSent = 0;
    
    // bodyで受けるが、実際に送信するのは
    // button / a / input / select / textarea のみ
		document.body.addEventListener('click', function (event) {

			// 連打よけ
			const now = Date.now();
  		if (now - lastSent < 50) return; // 50ms以内は無視する
  		lastSent = now;

      const el = event.target.closest('button, a, input, select, textarea'); // この要素以外はPOSTしない
      if (!el) return;

      // -------------------------
      // 画像クリックの対応
      // -------------------------
      let imageSrc = null;
      const img = event.target.closest('img');
      if (img) {
        imageSrc = img.src;
      }

      const payload = {
        element: el.tagName,
        id: el.id || null,
        class: el.className || null,
        label: el.dataset.label || null,
        text: el.innerText || el.value || null,
        image_src: imageSrc, // 画像パス

        url: window.location.href,
        referrer: document.referrer || null,
        timestamp: new Date().toISOString(),
        timestamp_jst: new Date().toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" }),
        timezone_offset: new Date().getTimezoneOffset()
      };

      fetch('/api/keen_events', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          event_type: 'clicks',
          payload: payload
        })
      })
      .then(res => {
        if (!res.ok) {
          console.warn('Keen click blocked:', res.status);
        }
      })
      .catch(err => console.error('Failed to send click event:', err));
    });

  });
}
